var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiDeleteNewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1666 4V13.3333C13.1666 13.687 13.0261 14.0261 12.7761 14.2761C12.526 14.5262 12.1869 14.6667 11.8333 14.6667H5.16659C4.81296 14.6667 4.47382 14.5262 4.22378 14.2761C3.97373 14.0261 3.83325 13.687 3.83325 13.3333V4",
    stroke: "#FF3B30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4H14.5",
    stroke: "#FF3B30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 3.99967V2.66634C5.83325 2.31272 5.97373 1.97358 6.22378 1.72353C6.47383 1.47348 6.81296 1.33301 7.16659 1.33301H9.83325C10.1869 1.33301 10.526 1.47348 10.7761 1.72353C11.0261 1.97358 11.1666 2.31272 11.1666 2.66634V3.99967",
    stroke: "#FF3B30",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiDeleteNewIcon);
export default __webpack_public_path__ + "static/media/APIDeleteNewIcon.dc68cadebad320620276315e65d579bf.svg";
export { ForwardRef as ReactComponent };